import classNames from "classnames";
import { AppNewInput } from "../../../../shared/components/AppNewInput";
import { useTranslation } from "react-i18next";
import { ClearButton } from "../../../Components/Buttons/ClearButton";
import { TSidebarActions } from "../../types";
import { TEntityInfo } from "../../../types/utility";
import styles from "./styles.module.css";

interface Props {
  searchQuery: string;
  isSearchPanelOpen: boolean;
  handleSearchActions: (
    type: TSidebarActions,
    info: TEntityInfo | null,
    e?: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  isSidebarOpen: boolean;
}

export const SidebarSearchPanel = ({
  searchQuery,
  isSearchPanelOpen,
  handleSearchActions,
  isSidebarOpen,
}: Props) => {
  const { t } = useTranslation();
  const searchInputCls = classNames(
    styles["search-input"],
    isSearchPanelOpen && isSidebarOpen && styles["search-input-open"],
    !isSidebarOpen && styles["search-input-popover"],
  );
  return (
    <AppNewInput
      value={searchQuery}
      onChange={(e) => handleSearchActions("search_object_selecting", null, e)}
      inputType={"borderless"}
      placeholder={t("common.search_input_placeholder")}
      endAdornment={
        <ClearButton
          typeBtn={"icon_btn"}
          onClick={(e) => {
            e.preventDefault();
            handleSearchActions("clear", null);
          }}
          iconType={"eraser"}
        />
      }
      className={searchInputCls}
    />
  );
};
